import type { HTMLAttributes } from "react";
import { cn } from "@/lib/cn";

export type Espacio = 1 | 2 | 3 | 4 | 6 | 8;

// Clases literales (Tailwind no detecta clases armadas concatenando strings)
const GAP: Record<Espacio, string> = { 1: "gap-1", 2: "gap-2", 3: "gap-3", 4: "gap-4", 6: "gap-6", 8: "gap-8" };

export interface StackProps extends HTMLAttributes<HTMLDivElement> {
  espacio?: Espacio;
}

/** Apila en vertical. */
export function Stack({ espacio = 4, className, ...props }: StackProps) {
  return <div className={cn("flex flex-col", GAP[espacio], className)} {...props} />;
}

export interface RowProps extends HTMLAttributes<HTMLDivElement> {
  espacio?: Espacio;
  alinear?: "inicio" | "centro" | "fin";
  justificar?: "inicio" | "centro" | "fin" | "entre";
  envolver?: boolean;
}

const ALINEAR = { inicio: "items-start", centro: "items-center", fin: "items-end" };
const JUSTIFICAR = { inicio: "justify-start", centro: "justify-center", fin: "justify-end", entre: "justify-between" };

/** Pone en fila (horizontal). */
export function Row({ espacio = 2, alinear = "centro", justificar = "inicio", envolver = false, className, ...props }: RowProps) {
  return (
    <div
      className={cn("flex flex-row", GAP[espacio], ALINEAR[alinear], JUSTIFICAR[justificar], envolver && "flex-wrap", className)}
      {...props}
    />
  );
}
